export default {"src":"/_next/static/media/Revoke_user.1edfd828.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};